module.exports = __webpack_public_path__ + "static/img/hot-line.117fcd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hot-line.png
// module id = 26SP
// module chunks = 10